var _g, _path, _path2;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgLockedIcon(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "locked-icon",
    xmlns: "http://www.w3.org/2000/svg",
    width: 14.7,
    stroke: "#A2A2A2",
    fill: "currentColor",
    height: 21.9,
    viewBox: "0 0 14.7 14.7",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_3",
    "data-name": "Group 3",
    transform: "translate(0 6)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_19",
    "data-name": "Path 19",
    d: "M48.1,42.8H34.2a.43.43,0,0,1-.4-.4V34.5a.43.43,0,0,1,.4-.4H48.1a.43.43,0,0,1,.4.4v7.9A.366.366,0,0,1,48.1,42.8Zm-13.5-.7H47.8V35H34.6Z",
    transform: "translate(-33.8 -34.1)",
    fill: "#231f20"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Path_20",
    "data-name": "Path 20",
    d: "M42.1,40.1H40.3a.43.43,0,0,1-.4-.4V37.3a.43.43,0,0,1,.4-.4h1.8a.43.43,0,0,1,.4.4v2.4C42.4,39.9,42.3,40.1,42.1,40.1Zm-1.5-.7h1.1V37.7H40.6Z",
    transform: "translate(-33.8 -28.1)",
    fill: "#231f20"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    id: "Path_21",
    "data-name": "Path 21",
    d: "M47.5,34.9a.43.43,0,0,1-.4-.4,5.96,5.96,0,0,0-6-5.7,6.027,6.027,0,0,0-6,5.7.4.4,0,0,1-.8,0,6.707,6.707,0,0,1,13.4,0c.2.3,0,.4-.2.4Z",
    transform: "translate(-33.8 -28.1)",
    fill: "#231f20"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLockedIcon);
export default __webpack_public_path__ + "static/media/locked-icon.af65dbb728b96be59b4c280d91027135.svg";
export { ForwardRef as ReactComponent };